window.Products.Clothing.YouthLeggings6to7years = function() {};

window.Products.Clothing.YouthLeggings6to7years.inherits(window.Products.Clothing.YouthLeggings);
window.Products.Clothing.YouthLeggings6to7years.has_3d = true;
window.Products.Clothing.YouthLeggings6to7years.id = '60-6to7years';
window.Products.Clothing.YouthLeggings6to7years.saveId = 60;
window.Products.Clothing.YouthLeggings6to7years.slug = 'youth-leggings-6to7years';
window.Products.Clothing.YouthLeggings6to7years.dpi = 150;